import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingClient } from '../httpClients/BillingClient';
import { GetBillingInfoResponse } from '../httpClients/BillingClient/api.schema';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<GetBillingInfoResponse>,
  'queryKey' | 'queryFn'
>;

export const useBillingInfoQuery = (queryOptions: OmittedQueryOptions = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.BILLING_INFO],
    queryFn: () => BillingClient.getBillingInfo(),
    ...queryOptions,
  });
